import { HandymanJobPage } from '@/index/service-category/handyman/HandymanJobPage'
import { PageAnalytics } from '@/commons/PageAnalytics'
import { getJobPageStaticProps } from 'utils/handyman-job-page-props'

// Copy lives in data/handyman-job-pages.js under 'ceiling-fan-installation'.
export const getStaticProps = () => getJobPageStaticProps('ceiling-fan-installation')

export default function Page(props) {
  return (
    <>
      <HandymanJobPage {...props} />
      <PageAnalytics />
    </>
  )
}
